import { __asStr } from "@tennis-matches/core/utils";
import { computeKoWinners } from "./computeKoWinners.js";

export function materializeKoMatches({ schedule, resultsItems }) {
  const ko = schedule?.ko;
  if (!ko) return [];

  const winnersByRound = computeKoWinners({ schedule, resultsItems });

  // Round 0 pidBySlot from ko.slots (global slots only for round 0)
  const pidBySlotR0 = new Map(
    (ko.slots || []).map((s) => [Number(s.slot), __asStr(s.entrant?.pid || "")])
  );

  // We materialize rounds in order, keeping a mapping:
  // roundEntrantPid[roundIndex][slot] = pid
  const roundEntrantPid = {};
  roundEntrantPid[0] = {};
  for (const [slot, pid] of pidBySlotR0.entries()) roundEntrantPid[0][slot] = pid;

  const out = [];

  const roundsSorted = (ko.rounds || []).slice().sort((a, b) => Number(a.roundIndex ?? 0) - Number(b.roundIndex ?? 0));

  for (const round of roundsSorted) {
    const rIdx = Number(round.roundIndex ?? 0);
    const curMap = (roundEntrantPid[rIdx] = roundEntrantPid[rIdx] || {});
    const prevMap = roundEntrantPid[rIdx - 1] || {};

    for (const m of round.matches || []) {
      const id = __asStr(m.id);
      const matchIndex = Number(m.matchIndex ?? 0);
      const roundSize = Number(m.roundSize ?? round.roundSize ?? 0);
      const aSlot = Number(m.aSlot);
      const bSlot = Number(m.bSlot);

      // participants for this round:
      const aId = rIdx === 0 ? __asStr(curMap[aSlot] || "") : __asStr(prevMap[aSlot] || "");
      const bId = rIdx === 0 ? __asStr(curMap[bSlot] || "") : __asStr(prevMap[bSlot] || "");

      const status = aId && bId ? "ready" : "waiting";

      out.push({
        id,
        roundIndex: rIdx,
        matchIndex,
        roundSize,
        aSlot,
        bSlot,
        aId: aId || null,
        bId: bId || null,
        status,
      });

      // compute winner pid for next round slot = matchIndex
      const winnerSide = winnersByRound?.[rIdx]?.[matchIndex];
      if (winnerSide === "A" && aId) {
        roundEntrantPid[rIdx + 1] = roundEntrantPid[rIdx + 1] || {};
        roundEntrantPid[rIdx + 1][matchIndex] = aId;
      } else if (winnerSide === "B" && bId) {
        roundEntrantPid[rIdx + 1] = roundEntrantPid[rIdx + 1] || {};
        roundEntrantPid[rIdx + 1][matchIndex] = bId;
      }
    }
  }

  if (ko.thirdPlace) {
    out.push({
      id: __asStr(ko.thirdPlace.id),
      roundIndex: 999,
      matchIndex: 1,
      aId: null,
      bId: null,
      status: "waiting",
      roundSize: 2,
      type: "thirdPlace",
    });
  }

  return out;
}
